// removed by extract-text-webpack-plugin
module.exports = {"BurgerBuilder":"BurgerBuilder__BurgerBuilder__1gdQN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BurgerBuilder/BurgerBuilder.css
// module id = 133
// module chunks = 0